// src/actions/actionTypes.js

// Cottages Action Types
export const FETCH_COTTAGES_REQUEST = "FETCH_COTTAGES_REQUEST";
export const FETCH_COTTAGES_SUCCESS = "FETCH_COTTAGES_SUCCESS";
export const FETCH_COTTAGES_FAILURE = "FETCH_COTTAGES_FAILURE";

export const FETCH_COTTAGE_DETAILS_REQUEST = "FETCH_COTTAGE_DETAILS_REQUEST";
export const FETCH_COTTAGE_DETAILS_SUCCESS = "FETCH_COTTAGE_DETAILS_SUCCESS";
export const FETCH_COTTAGE_DETAILS_FAILURE = "FETCH_COTTAGE_DETAILS_FAILURE";

// Customs Declarations Action Types
export const FETCH_DECLARATIONS_REQUEST = "FETCH_DECLARATIONS_REQUEST";
export const FETCH_DECLARATIONS_SUCCESS = "FETCH_DECLARATIONS_SUCCESS";
export const FETCH_DECLARATIONS_FAILURE = "FETCH_DECLARATIONS_FAILURE";

// Declaration Details Action Types
export const FETCH_DECLARATION_DETAILS_REQUEST =
  "FETCH_DECLARATION_DETAILS_REQUEST";
export const FETCH_DECLARATION_DETAILS_SUCCESS =
  "FETCH_DECLARATION_DETAILS_SUCCESS";
export const FETCH_DECLARATION_DETAILS_FAILURE =
  "FETCH_DECLARATION_DETAILS_FAILURE";

// Goods Action Types
export const FETCH_GOODS_REQUEST = "FETCH_GOODS_REQUEST";
export const FETCH_GOODS_SUCCESS = "FETCH_GOODS_SUCCESS";
export const FETCH_GOODS_FAILURE = "FETCH_GOODS_FAILURE";

// Customs Duty Info Action Types
export const FETCH_CUSTOMS_DUTY_REQUEST = "FETCH_CUSTOMS_DUTY_REQUEST";
export const FETCH_CUSTOMS_DUTY_SUCCESS = "FETCH_CUSTOMS_DUTY_SUCCESS";
export const FETCH_CUSTOMS_DUTY_FAILURE = "FETCH_CUSTOMS_DUTY_FAILURE";

// Save Data Action Types
export const SAVE_DATA_REQUEST = "SAVE_DATA_REQUEST";
export const SAVE_DATA_SUCCESS = "SAVE_DATA_SUCCESS";
export const SAVE_DATA_FAILURE = "SAVE_DATA_FAILURE";

export const UPDATE_COTTAGE_CURRENCY_PRICE_REQUEST =
  "UPDATE_COTTAGE_CURRENCY_PRICE_REQUEST";
export const UPDATE_COTTAGE_CURRENCY_PRICE_SUCCESS =
  "UPDATE_COTTAGE_CURRENCY_PRICE_SUCCESS";
export const UPDATE_COTTAGE_CURRENCY_PRICE_FAILURE =
  "UPDATE_COTTAGE_CURRENCY_PRICE_FAILURE";

export const SET_CUSTOMS_PARAMS = "SET_CUSTOMS_PARAMS";
export const CLEAR_CUSTOMS_PARAMS = "CLEAR_CUSTOMS_PARAMS";

// Save Multiple Declarations Actions

export const SAVE_MULTIPLE_DECLARATIONS_REQUEST =
  "SAVE_MULTIPLE_DECLARATIONS_REQUEST";
export const SAVE_MULTIPLE_DECLARATIONS_PROGRESS =
  "SAVE_MULTIPLE_DECLARATIONS_PROGRESS";
export const SAVE_MULTIPLE_DECLARATIONS_SUCCESS =
  "SAVE_MULTIPLE_DECLARATIONS_SUCCESS";
export const SAVE_MULTIPLE_DECLARATIONS_FAILURE =
  "SAVE_MULTIPLE_DECLARATIONS_FAILURE";

export const FETCH_PERFORMAS_REQUEST = "FETCH_PERFORMAS_REQUEST";
export const FETCH_PERFORMAS_SUCCESS = "FETCH_PERFORMAS_SUCCESS";
export const FETCH_PERFORMAS_FAILURE = "FETCH_PERFORMAS_FAILURE";

export const SAVE_SELECTED_PERFORMAS_REQUEST =
  "SAVE_SELECTED_PERFORMAS_REQUEST";
export const SAVE_SELECTED_PERFORMAS_SUCCESS =
  "SAVE_SELECTED_PERFORMAS_SUCCESS";
export const SAVE_SELECTED_PERFORMAS_FAILURE =
  "SAVE_SELECTED_PERFORMAS_FAILURE";

export const COTTAGE_UPDATE_REQUEST = "COTTAGE_UPDATE_REQUEST";
export const COTTAGE_UPDATE_SUCCESS = "COTTAGE_UPDATE_SUCCESS";
export const COTTAGE_UPDATE_FAILURE = "COTTAGE_UPDATE_FAILURE";

export const FETCH_REGED_ORDERS_REQUEST = "FETCH_REGED_ORDERS_REQUEST";
export const FETCH_REGED_ORDERS_SUCCESS = "FETCH_REGED_ORDERS_SUCCESS";
export const FETCH_REGED_ORDERS_FAILURE = "FETCH_REGED_ORDERS_FAILURE";

export const UPDATE_ORDER_STATUS_REQUEST = "UPDATE_ORDER_STATUS_REQUEST";
export const UPDATE_ORDER_STATUS_SUCCESS = "UPDATE_ORDER_STATUS_SUCCESS";
export const UPDATE_ORDER_STATUS_FAILURE = "UPDATE_ORDER_STATUS_FAILURE";

export const CREATE_COTTAGE_REQUEST = "CREATE_COTTAGE_REQUEST";
export const CREATE_COTTAGE_SUCCESS = "CREATE_COTTAGE_SUCCESS";
export const CREATE_COTTAGE_FAILURE = "CREATE_COTTAGE_FAILURE";
export const RESET_COTTAGE_CREATION = "RESET_COTTAGE_CREATION";

// src/redux/auth/authActionTypes.js

export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const AUTH_ERROR = "AUTH_ERROR";
export const TOKEN_REFRESH_SUCCESS = "TOKEN_REFRESH_SUCCESS";
export const TOKEN_REFRESH_FAIL = "TOKEN_REFRESH_FAIL";

export const FETCH_PERFORMA_REQUEST = "FETCH_PERFORMA_REQUEST";
export const FETCH_PERFORMA_SUCCESS = "FETCH_PERFORMA_SUCCESS";
export const FETCH_PERFORMA_FAILURE = "FETCH_PERFORMA_FAILURE";

export const DELETE_COTTAGES_REQUEST = "DELETE_COTTAGES_REQUEST";
export const DELETE_COTTAGES_SUCCESS = "DELETE_COTTAGES_SUCCESS";
export const DELETE_COTTAGES_FAILURE = "DELETE_COTTAGES_FAILURE";

export const DELETE_PERFORMAS_REQUEST = "DELETE_PERFORMAS_REQUEST";
export const DELETE_PERFORMAS_SUCCESS = "DELETE_PERFORMAS_SUCCESS";
export const DELETE_PERFORMAS_FAILURE = "DELETE_PERFORMAS_FAILURE";

export const ADD_PERFORMA_REQUEST = "ADD_PERFORMA_REQUEST";
export const ADD_PERFORMA_SUCCESS = "ADD_PERFORMA_SUCCESS";
export const ADD_PERFORMA_FAILURE = "ADD_PERFORMA_FAILURE";
export const RESET_ADD_PERFORMA = "RESET_ADD_PERFORMA";

export const UPDATE_GOOD_REQUEST = "UPDATE_GOOD_REQUEST";
export const UPDATE_GOOD_SUCCESS = "UPDATE_GOOD_SUCCESS";
export const UPDATE_GOOD_FAILURE = "UPDATE_GOOD_FAILURE";

export const FETCH_REPRESENTATIONS_REQUEST = "FETCH_REPRESENTATIONS_REQUEST";
export const FETCH_REPRESENTATIONS_SUCCESS = "FETCH_REPRESENTATIONS_SUCCESS";
export const FETCH_REPRESENTATIONS_FAILURE = "FETCH_REPRESENTATIONS_FAILURE";

export const CREATE_REPRESENTATION_SUCCESS = "CREATE_REPRESENTATION_SUCCESS";
export const CREATE_REPRESENTATION_FAILURE = "CREATE_REPRESENTATION_FAILURE";

export const UPDATE_REPRESENTATION_SUCCESS = "UPDATE_REPRESENTATION_SUCCESS";
export const UPDATE_REPRESENTATION_FAILURE = "UPDATE_REPRESENTATION_FAILURE";

export const DELETE_REPRESENTATION_SUCCESS = "DELETE_REPRESENTATION_SUCCESS";
export const DELETE_REPRESENTATION_FAILURE = "DELETE_REPRESENTATION_FAILURE";

export const FETCH_CHECKS_REQUEST = "FETCH_CHECKS_REQUEST";
export const FETCH_CHECKS_SUCCESS = "FETCH_CHECKS_SUCCESS";
export const FETCH_CHECKS_FAILURE = "FETCH_CHECKS_FAILURE";

export const CREATE_CHECK_SUCCESS = "CREATE_CHECK_SUCCESS";
export const CREATE_CHECK_FAILURE = "CREATE_CHECK_FAILURE";

export const UPDATE_CHECK_SUCCESS = "UPDATE_CHECK_SUCCESS";
export const UPDATE_CHECK_FAILURE = "UPDATE_CHECK_FAILURE";

export const DELETE_CHECK_SUCCESS = "DELETE_CHECK_SUCCESS";
export const DELETE_CHECK_FAILURE = "DELETE_CHECK_FAILURE";

export const FETCH_PRF_DASHBOARD_REQUEST = "FETCH_PRF_DASHBOARD_REQUEST";
export const FETCH_PRF_DASHBOARD_SUCCESS = "FETCH_PRF_DASHBOARD_SUCCESS";
export const FETCH_PRF_DASHBOARD_FAILURE = "FETCH_PRF_DASHBOARD_FAILURE";

export const FETCH_COT_DASHBOARD_REQUEST = "FETCH_COT_DASHBOARD_REQUEST";
export const FETCH_COT_DASHBOARD_SUCCESS = "FETCH_COT_DASHBOARD_SUCCESS";
export const FETCH_COT_DASHBOARD_FAILURE = "FETCH_COT_DASHBOARD_FAILURE";

export const FETCH_EXPORT_DECLARATIONS_REQUEST =
  "FETCH_EXPORT_DECLARATIONS_REQUEST";
export const FETCH_EXPORT_DECLARATIONS_SUCCESS =
  "FETCH_EXPORT_DECLARATIONS_SUCCESS";
export const FETCH_EXPORT_DECLARATIONS_FAILURE =
  "FETCH_EXPORT_DECLARATIONS_FAILURE";

export const CREATE_EXPORT_COTTAGE_REQUEST = "CREATE_EXPORT_COTTAGE_REQUEST";
export const CREATE_EXPORT_COTTAGE_SUCCESS = "CREATE_EXPORT_COTTAGE_SUCCESS";
export const CREATE_EXPORT_COTTAGE_FAILURE = "CREATE_EXPORT_COTTAGE_FAILURE";

// New action types for saving exported cottages
export const SAVE_EXPORTED_COTTAGES_REQUEST = "SAVE_EXPORTED_COTTAGES_REQUEST";
export const SAVE_EXPORTED_COTTAGES_PROGRESS =
  "SAVE_EXPORTED_COTTAGES_PROGRESS";
export const SAVE_EXPORTED_COTTAGES_SUCCESS = "SAVE_EXPORTED_COTTAGES_SUCCESS";
export const SAVE_EXPORTED_COTTAGES_FAILURE = "SAVE_EXPORTED_COTTAGES_FAILURE";

export const FETCH_EXPORT_COTTAGE_REQUEST = "FETCH_EXPORT_COTTAGE_REQUEST";
export const FETCH_EXPORT_COTTAGE_SUCCESS = "FETCH_EXPORT_COTTAGE_SUCCESS";
export const FETCH_EXPORT_COTTAGE_FAILURE = "FETCH_EXPORT_COTTAGE_FAILURE";

export const FETCH_EXPORT_COTTAGE_DETAILS_REQUEST =
  "FETCH_EXPORT_COTTAGE_DETAILS_REQUEST";
export const FETCH_EXPORT_COTTAGE_DETAILS_SUCCESS =
  "FETCH_EXPORT_COTTAGE_DETAILS_SUCCESS";
export const FETCH_EXPORT_COTTAGE_DETAILS_FAILURE =
  "FETCH_EXPORT_COTTAGE_DETAILS_FAILURE";

export const EXPORT_COTTAGE_UPDATE_REQUEST = "EXPORT_COTTAGE_UPDATE_REQUEST";
export const EXPORT_COTTAGE_UPDATE_SUCCESS = "EXPORT_COTTAGE_UPDATE_SUCCESS";
export const EXPORT_COTTAGE_UPDATE_FAILURE = "EXPORT_COTTAGE_UPDATE_FAILURE";

export const IMPORT_PERFORMA_REQUEST = "IMPORT_PERFORMA_REQUEST";
export const IMPORT_PERFORMA_SUCCESS = "IMPORT_PERFORMA_SUCCESS";
export const IMPORT_PERFORMA_FAILURE = "IMPORT_PERFORMA_FAILURE";

export const IMPORT_EXPORTED_COTTAGES_REQUEST =
  "IMPORT_EXPORTED_COTTAGES_REQUEST";
export const IMPORT_EXPORTED_COTTAGES_SUCCESS =
  "IMPORT_EXPORTED_COTTAGES_SUCCESS";
export const IMPORT_EXPORTED_COTTAGES_FAILURE =
  "IMPORT_EXPORTED_COTTAGES_FAILURE";

export const FETCH_HSCODE_REQUEST = "FETCH_HSCODE_REQUEST";
export const FETCH_HSCODE_SUCCESS = "FETCH_HSCODE_SUCCESS";
export const FETCH_HSCODE_FAILURE = "FETCH_HSCODE_FAILURE";

export const FETCH_HSCODE_LIST_REQUEST = "FETCH_HSCODE_LIST_REQUEST";
export const FETCH_HSCODE_LIST_SUCCESS = "FETCH_HSCODE_LIST_SUCCESS";
export const FETCH_HSCODE_LIST_FAILURE = "FETCH_HSCODE_LIST_FAILURE";

export const FETCH_ALL_HSCODE_REQUEST = "FETCH_ALL_HSCODE_REQUEST";
export const FETCH_ALL_HSCODE_SUCCESS = "FETCH_ALL_HSCODE_SUCCESS";
export const FETCH_ALL_HSCODE_FAILURE = "FETCH_ALL_HSCODE_FAILURE";

export const IMPORT_REQUEST = "IMPORT_REQUEST";
export const IMPORT_SUCCESS = "IMPORT_SUCCESS";
export const IMPORT_FAILURE = "IMPORT_FAILURE";

export const FETCH_HSCODE_DETAIL_REQUEST = "FETCH_HSCODE_DETAIL_REQUEST";
export const FETCH_HSCODE_DETAIL_SUCCESS = "FETCH_HSCODE_DETAIL_SUCCESS";
export const FETCH_HSCODE_DETAIL_FAILURE = "FETCH_HSCODE_DETAIL_FAILURE";

export const IMPORT_REPRESENTATION_REQUEST = "IMPORT_REPRESENTATION_REQUEST";
export const IMPORT_REPRESENTATION_SUCCESS = "IMPORT_REPRESENTATION_SUCCESS";
export const IMPORT_REPRESENTATION_FAILURE = "IMPORT_REPRESENTATION_FAILURE";

export const FETCH_COSTUMER_LIST_REQUEST = "FETCH_COSTUMER_LIST_REQUEST";
export const FETCH_COSTUMER_LIST_SUCCESS = "FETCH_COSTUMER_LIST_SUCCESS";
export const FETCH_COSTUMER_LIST_FAILURE = "FETCH_COSTUMER_LIST_FAILURE";

export const FETCH_GODDS_LIST_REQUEST = "FETCH_GODDS_LIST_REQUEST";
export const FETCH_GODDS_LIST_SUCCESS = "FETCH_GODDS_LIST_SUCCESS";
export const FETCH_GODDS_LIST_FAILURE = "FETCH_GODDS_LIST_FAILURE";